<!--  -->
<template>
  <div class="personnel">
    <div class="title" style="width: 43.6%;">
      <div class="title-text">人员管理</div>
    </div>
    <div class="content">
      <div class="cleft">
        <div class="cleft-item">
          <div style="font-size:2.1vh;color:#98fef9;font-weight: 600;">985</div>
          <div>入场人数</div>
        </div>
        <div class="cleft-item">
          <div style="font-size:2.1vh;color:#98fef9;font-weight: 600;">587</div>
          <div>在场人数</div>
        </div>
        <div class="cleft-item">
          <div style="font-size:2.1vh;color:#98fef9;font-weight: 600;">398</div>
          <div>离场人数</div>
        </div>
      </div>
      <div class="temper-box">
        <div class="temper-list">
          <div class="temper-top top">
            <div class>设备编号</div>
            <div class style="margin-left:-24px">设备名称</div>
            <div class>温度</div>
            <div class>序号</div>
          </div>
          <div class="temper-bottom">
            <div class="temper-bottom-info">
              <span>0001</span>
              <span>654001</span>
              <span>王XX</span>
              <span style="color:rgb(26, 131, 121);">在岗</span>
              <!-- <div class="temper-bottom-info-bg"></div> -->
            </div>
          </div>
        </div>
        <div class="temper-list">
          <div class="temper-top">
            <div class>0002</div>
            <div class>654002</div>
            <div class>周XX</div>
            <span style="color:rgb(26, 131, 121);">在岗</span>
          </div>
          <div class="temper-bottom">
            <div class="temper-bottom-info" style="color:rgb(255, 150, 0);;">
              <span>0003</span>
              <span>654003</span>
              <span>赵XX</span>
              <span>离岗</span>
              <!-- <div class="temper-bottom-info-bg"></div> -->
            </div>
          </div>
        </div>
        <div class="temper-list">
          <div class="temper-top">
            <div class>0004</div>
            <div class>654004</div>
            <div class>李XX</div>
            <span style="color:rgb(26, 131, 121);">在岗</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.personnel {
  height: 21.8vh;
  width: 29vw;
  margin-left: 3vw;
  //   background: red;
  .content {
    display: flex;
    .cleft {
      width: 25%;
      margin-top: 1.2vh;
      color: #fff;
      font-family: sy;
      text-align: center;
      font-size: 1.1vh;
      .cleft-item {
        width: 100px;
        height: 5vh;
        background: url(../../assets/box2.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-bottom: 1vh;
      }
    }
    .temper-box {
      font-family: sy;
      width: 75%;

      font-size: 12px;
      color: white;

      .temper-list {
        margin-top: 0.9vh;
        .temper-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.4vh 10px;
          box-sizing: border-box;
          background: url("./../../assets/img/box.png");
          background-size: 100% 100%;
          &.top {
            background: url("./../../assets/titlebox.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }

        .temper-bottom {
          .temper-bottom-info {
            position: relative;

            padding: 0.4vh 10px;
            padding-top: 2vh;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .temper-bottom-info-bg {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 2px;
              background: url("./../../assets/img/list.png") no-repeat;
            }
          }
        }
      }
    }
  }
}
</style>